module.exports = __webpack_public_path__ + "static/media/logo_3divi_s_white.ad2817c4.svg";